export const WS_CONNECT = 'WS_CONNECT'
export const WS_CONNECTING = 'WS_CONNECTING'
export const WS_CONNECTED = 'WS_CONNECTED'

export const WS_DISCONNECT = 'WS_DISCONNECT'
export const WS_DISCONNECTED = 'WS_DISCONNECTED'

export const API_GET_CONNECTED_USERS_WS = 'API_GET_CONNECTED_USERS_WS'
export const API_GET_CONNECTED_USERS_WS_SUCCESS = 'API_GET_CONNECTED_USERS_WS_SUCCESS'

export const API_POST_DISCONNECTED_USERS_WS = 'API_POST_DISCONNECTED_USERS_WS'
